module.exports = __webpack_public_path__ + "static/media/c59.b1a8d011.png";